<template>
<div xxxstyle="max-width:100%">
    <div ref="diagram">
        <div v-for="(group, groupIndex) in groups" style="position:relative" class="diagram-group" :key="groupIndex">
            <div style="position:absolute;right:-11px;top:-11px;background-color:white">
                <v-menu>
                <template v-slot:activator="{ on }">
                <v-icon v-on="on" color="primary">add_circle</v-icon>
                </template>
                <v-list>
                    <v-list-item @click="editLoan(null, null, groupIndex)">
                        <v-list-item-title>Add loan</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="editProperty(null, null, groupIndex)">
                        <v-list-item-title>Add property</v-list-item-title>
                    </v-list-item> 
                    <v-list-item @click="addGroup">
                        <v-list-item-title>Add group</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="groups.length > 1" @click="removeGroup(groupIndex)">
                        <v-list-item-title>Remove group</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="copyToClipboard">
                        <v-list-item-title>Copy to Clipboard</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="wordWrap = !wordWrap">
                        <v-list-item-title>Word Wrap</v-list-item-title>
                        <v-icon v-if="wordWrap">check</v-icon>
                    </v-list-item>
                    
                </v-list>
                </v-menu>
            </div>
            
            <!-- loans -->
            <div style="display:flex">
                <div v-for="(loan, loanIndex) in group.loans" style="display:flex" :style="{'flex-basis': loan.meta.width + '%', 'flex-shrink': loan.meta.width}" :class="loanClass(loan)" :key="loanIndex" @click="editLoan(loan, loanIndex, groupIndex)">
                    <div style="flex-grow:1">
                        <span class="amount">{{loan.meta.amountTotal | thousands }}</span>
                        {{loanDescription(loan)}}
                    </div>
                </div>

                <v-menu offset-y>
                <template v-slot:activator="{ on }">
                <div v-on="on" class="diagram-space diagram-bar" :style="{'flex-basis': (100-group.lvr) + '%'}">{{group.lvr}}%</div>
                </template>
                <v-list>
                    <v-list-item @click="adjustLVR(92, groupIndex)">
                        <v-list-item-title>92%</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="adjustLVR(90, groupIndex)">
                        <v-list-item-title>90%</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="adjustLVR(88, groupIndex)">
                        <v-list-item-title>88%</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="adjustLVR(85, groupIndex)">
                        <v-list-item-title>85%</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="adjustLVR(80, groupIndex)">
                        <v-list-item-title>80%</v-list-item-title>
                    </v-list-item>
                    
                </v-list>
                </v-menu>

                
            </div>
            
            <!-- properties -->
            <div style="display:flex">
                <div v-for="(property, propertyIndex) in group.properties" :style="{'flex-basis': property.meta.width + '%'}" :class="propertyClass(property)" :key="propertyIndex" @click="editProperty(property, propertyIndex, groupIndex)">
                    {{property.value | thousands}}
                    <span style="color:rgba(255, 255, 255, 0.7)" v-if="property.address && $vuetify.breakpoint.mdAndUp"> - {{property.address}}</span>
                    <span v-if="property.existing"> (Existing)</span>
                </div>
            </div>
        </div>
        <!-- Summary  -->
        <div>
            <template v-for="attribute in summary" >
                <v-chip :title="attribute.name" @click="selectAttribute(attribute)" class="attribute-chip mt-1 mr-1 grey--text text--darken-1" :class="{selected: attribute == selectedAttribute}" v-if="isPositiveAmount(attribute.value)" small :key="attribute.name">{{attribute.title}}: {{attribute.value | currency}}</v-chip>
            </template>
        </div>
    </div>

    <!-- <div v-html="description"></div> -->

    <!-- Loan Dialog -->

    <DialogBox title="Loan Details" :settings="loanDialog.settings" save-on-enter @save="saveLoan(loanDialog.loan)">
        <div class="pa-4">
            <div class="blue--text text--darken-2" style="margin-top:-15px" :style="{'visibility': activeLoanPayment ? 'visible' : 'hidden'}">
                <span v-if="loanDialog.loan.io">IO </span>
                Repayment {{activeLoanPayment | currency}}pm
                 | {{activeLoanPayment * 12 / 52 | currency}}pw

            </div>
            <div style="display:flex">
                <!-- <v-text-field ref="focus" v-model.number.lazy="loanDialog.loan.amount" label="Base Amount" style="margin-right:10px" /> -->
                <currency-box ref="focus" v-model.number.lazy="loanDialog.loan.amount" label="Base Amount" style="margin-right:10px" />
                <v-select v-bind:items="lmiOptions" v-model="loanDialog.loan.lmiType" label="LMI" style="margin-right:10px" ></v-select>
                <currency-box v-model.number="loanDialog.loan.lmi" label="Est LMI" />
            </div>

            <div style="display:flex">
                <v-text-field v-model.number="loanDialog.loan.rate" label="Rate %" style="margin-right:10px"/>
                <v-select v-bind:items="yearsOptions" v-model="loanDialog.loan.years" label="Years" style="margin-right:10px" ></v-select>
                <currency-box v-model="loanDialog.loan.newMoney" label="New Money (if different)" />
            </div>
            <div style="display:flex">
                <v-checkbox v-model="loanDialog.loan.package" label="Package" />
                <v-checkbox v-model="loanDialog.loan.special" label="Special" style="margin-left:15px"  />
                <v-checkbox v-model="loanDialog.loan.investment" label="Investment" style="margin-left:15px" />
                <v-checkbox v-model="loanDialog.loan.existing" label="Existing Debt Keeping" style="margin-left:15px" />
            </div>

            <div style="display:flex">
                <v-select v-bind:items="fixedOptions" v-model.number="loanDialog.loan.fixed" item-text="display" item-value="years" :label="(loanDialog.loan.fixed ? 'Fixed Period' : 'Fixed or Variable')" style="margin-right:10px" ></v-select>
                <div v-if="loanDialog.loan.fixed" style="flex-basis:180px">
                    <v-switch v-model="loanDialog.loan.rateLock" label="Rate Lock"/>
                </div>
                <v-select v-bind:items="ioOptions" v-model.number="loanDialog.loan.io" item-text="display" item-value="years" :label="(loanDialog.loan.io ? 'Interest Only Period' : 'P&I or IO')" ></v-select>
            </div>
            <div>
                <v-text-field v-model="loanDialog.loan.product" label="Product" hint="Include any offers or rebates"/>
            </div>
        </div>  
        <DeleteButton slot="footer" v-if="allowDeleteLoan(loanDialog.loan)" @delete="deleteLoan(loanDialog.loan)" style="float:left"></DeleteButton>

    </DialogBox>  

    <!-- Property Dialog -->

    <DialogBox title="Propety Details" :settings="propertyDialog.settings" save-on-enter @save="saveProperty(propertyDialog.model)">
        <div class="pa-4">
            <currency-box ref="focus" v-model.number="propertyDialog.model.value" label="Value" />
            <div style="display:flex">
                <v-checkbox v-model="propertyDialog.model.investment" label="Investment" />
                <v-checkbox style="margin-left:10px" v-model="propertyDialog.model.existing" label="Existing" />
            </div>
            <v-text-field v-model="propertyDialog.model.address" label="Address" />
            <v-select v-bind:items="propertyTypes" v-model="propertyDialog.model.type" label="Type" ></v-select>
        </div>  
        <DeleteButton slot="footer" v-if="allowDeleteProperty(propertyDialog.model)" @delete="deleteProperty(propertyDialog.model)" style="float:left"></DeleteButton>

    </DialogBox>  
    

</div>
</template>

<script>

import DialogBox from '../ui-elements/DialogBox'
import CurrencyBox from '../ui-elements/CurrencyBox'
import DeleteButton from '../ui-elements/DeleteButton'
import NumberHelpers from '../helpers/NumberHelpers'
import StringHelpers from '../helpers/StringHelpers'
import LoanHelpers from '../helpers/LoanHelpers'
import LoanSecurityHelpers from '../helpers/LoanSecurityHelpers'
// 
import Vue from 'vue'
import clipboard from 'clipboard-js'
import AlertHelpers from '../helpers/AlertHelpers';


export default {
    data() {
        return {
            selectedAttribute: {},
            lastChange: null,

            wordWrap: false,
            diagramData:[
                {
                    loans: [
                        {amount: 400000, fixed:0, io:0},
                    ],
                    properties: [
                        {value: 500000, type: 'House'},
                    ]
                },  
            ],
            
            loanDialog: {
                loan: {
                    amount: 0,
                    years: 30,
                },
                settings: {
                    visible: false,
                    title: 'Loan Details'
                }

            },
            propertyDialog: {
                model: {
                    amount: 0,
                },
                settings: {
                    visible: false,
                    title: 'Property Details'
                }
            }
        
        }
    },

    components: {
        DialogBox,
        DeleteButton,
        CurrencyBox,
    },
    
    props: {
        diagram: Array,
        passBack: Object,
    },

    computed: {
        activeLoanPayment() {
            const payment = LoanSecurityHelpers.loanPayment(this.loanDialog.loan)
            return payment
        },

        summary() {
            return LoanSecurityHelpers.loanSummary(this.groups)
        },
        
        descriptionObject() {
            return LoanSecurityHelpers.diagramDescription(this.groups)
        },

        descriptionWithSummaryObject() {
            const summaryDescription = LoanSecurityHelpers.loanSummaryDescription(this.groups)
            return {
                text: this.descriptionObject.text + '\n\n' + summaryDescription.text,
                html: this.descriptionObject.html + '<br/><br/>' + summaryDescription.html
            }
        },

        allLoans() {
            let loans = []
            this.diagramData.forEach(group => {
                loans = [...loans, ...group.loans]
            })
            return loans
        },

        allProperties() {
            let properties = []
            this.diagramData.forEach(group => {
                properties = [...properties, ...group.properties]
            })
            return properties
        },

        anyFixedLoans() {
            return Boolean(this.allLoans.find(o => o.fixed > 0))
        },

        anyioLoans() {
            return Boolean(this.allLoans.find(o => o.io > 0))
        },

        anyLMI() {
            return Boolean(this.allLoans.find(o => o.lmiType == 'Capitalised' || o.lmiType == 'Included'))
        },
 
        anyOwnerOccupied() {
            return Boolean(this.allProperties.find(o => !o.investment))
        },
 
        anyInvestmentProperties() {
            return Boolean(this.allProperties.find(o => o.investment))
        },
        

        groups() {
            return LoanHelpers.diagramDetails(this.diagramData)
        },

        fixedOptions() {
            return [
                {years: 0, display: 'Variable'},
                {years: 1, display: '1 Year Fixed'},
                {years: 2, display: '2 Years Fixed'},
                {years: 3, display: '3 Years Fixed'},
                {years: 4, display: '4 Years Fixed'},
                {years: 5, display: '5 Years Fixed'},
            ]
        },

        propertyTypes() {
            return [
              "House", "Townhouse", "Unit", "Land", "Build"
            ]
        },

        ioOptions() {
            return [
                {years: 0, display: 'Principal and Interest'},
                {years: 1, display: '1 Year IO'},
                {years: 2, display: '2 Years IO'},
                {years: 3, display: '3 Years IO'},
                {years: 4, display: '4 Years IO'},
                {years: 5, display: '5 Years IO'},
            ]
        },

        lmiOptions() {
            return ['None', 'Capitalised', 'Included']
        },

        yearsOptions() {
            let terms = []
            for(var n = 1; n < 31; n++) {
                terms.push(n)
            }
            return terms
        },

    },

    methods: {

        isPositiveAmount(val) {
            const result = val && NumberHelpers.isNumeric(val) && (val > 0)
            return result
        },

        selectAttribute(attribute) {
            if(attribute == this.selectedAttribute)
                this.selectedAttribute = {}
            else
                this.selectedAttribute = attribute
        },

        toggleWordWrap() {
            this.$set(this.diagramData, 'wordWrap', !this.wordWrap)
        },

        copyToClipboard() {
            clipboard.copy({
                'text/plain': this.descriptionWithSummaryObject.text,
                'text/html': this.descriptionWithSummaryObject.html,
            })
            AlertHelpers.showAlert('Copied to Clipboard')
        },

        loanDescription(loan) {
            let descriptions = []

            if(loan.rate)
                descriptions.push('@ ' + loan.rate + '%')
                
            if(loan.io && this.$vuetify.breakpoint.smAndUp)
                descriptions.push(loan.io + 'y IO')

            if(loan.fixed && this.$vuetify.breakpoint.smAndUp) {
                let fixedDescription = loan.fixed + 'y Fixed'
                if(loan.rateLock)
                    fixedDescription += ' RATE LOCK'
                descriptions.push(fixedDescription)
            }
                
            if(loan.years < 30 && this.$vuetify.breakpoint.smAndUp)
                descriptions.push(loan.years + 'yrs')

            if(loan.existing && this.$vuetify.breakpoint.mdAndUp)
                descriptions.push('Existing Lending Keeping')
            else if(loan.product && this.$vuetify.breakpoint.mdAndUp)
                descriptions.push(loan.product)
                
            let description = descriptions.join(', ')

            if(loan.lmi){
                const lmi = NumberHelpers.abbreviateNumber(loan.lmi)
                const amount = NumberHelpers.abbreviateNumber(loan.amount)
                if(loan.lmiType == 'Included')
                    description = `(incl ${lmi} lmi)`  + description
                else 
                    description = `(${amount} + ${lmi}) `  + description
            }

            return description 
            
        },

        allowDeleteLoan(loan) {
            if(!loan.loanIndex)
                return false
            
            if(this.groups[loan.groupIndex].loans.length < 2)
                return false
            
            return true
        },

        allowDeleteProperty(property) {
            if(!property.propertyIndex)
                return false
            
            if(this.groups[property.groupIndex].properties.length < 2)
                return false
            
            return true
        },

        editLoan(loan, loanIndex, groupIndex) {
            if(!loan)
                loan = { amount: 400000, years: 30 }

            this.loanDialog.loan = {
                ...loan, loanIndex, groupIndex
            }

            this.loanDialog.settings.visible = true
        },

        editProperty(property, propertyIndex, groupIndex) {
            if(!property)
                property = {value: 500000}
            this.propertyDialog.model = {
                ...property, propertyIndex, groupIndex
            }
            this.propertyDialog.settings.visible = true
        },

        addGroup() {
            this.diagramData.push({
                loans: [{
                    amount: 400000,
                }],
                properties: [{
                    value: 500000, type: 'House'
                }]
            })
            this.saveDiagram()

        },

        saveLoan(loan) {
            console.log('saving', loan)
            let loanIndex = loan.loanIndex
            let groupIndex = loan.groupIndex
            delete loan['loanIndex']
            delete loan['groupIndex']
            delete loan['meta']

            if(loanIndex == null) {
                this.diagramData[groupIndex].loans.push(loan)
            } else {
                let loans = this.diagramData[groupIndex].loans
                Vue.set(loans, loanIndex, loan)
            }
            this.saveDiagram()
        },

        saveProperty(property) {
            console.log('saving', property)
            let propertyIndex = property.propertyIndex
            let groupIndex = property.groupIndex
            delete property['propertyIndex']
            delete property['groupIndex']
            delete property['meta']
            if(propertyIndex == null) {
                this.diagramData[groupIndex].properties.push(property)
            } else {
                let properties = this.diagramData[groupIndex].properties
                Vue.set(properties, propertyIndex, property)
            }
            this.saveDiagram()

        },

        deleteLoan(loan) {
            this.diagramData[loan.groupIndex].loans.splice(loan.loanIndex, 1)
            this.loanDialog.settings.visible = false
            this.saveDiagram()

        },

        deleteProperty(property) {
            this.diagramData[property.groupIndex].properties.splice(property.propertyIndex, 1)
            this.propertyDialog.settings.visible = false
            this.saveDiagram()

        },

        removeGroup(groupIndex) {
            this.diagramData.splice(groupIndex, 1)
            this.saveDiagram()
        },

        loanClass(loan) {
            let classes =  'diagram-bar loan' 
            if(loan.existing)
                classes += " existing"
            else if(loan.investment)
                classes += ' investment'
            
            if(!this.wordWrap)
                classes += ' no-wrap'

            if(this.loanHasAttribute(loan, this.selectedAttribute.id))
                classes += ' selected'
                

            return classes
        },

        loanHasAttribute(loan, attributeId) {
 
            if(!attributeId)
                return false
            if(attributeId == 'ownerOccupied')
                return !loan.investment
            if(attributeId == 'variable')
                return !loan.fixed
            if(attributeId == 'principalAndInterest')
                return !loan.io

            return loan[attributeId]
        },

        propertyClass(property) {
            return 'diagram-bar property' 
                + (property.investment ? ' investment' : '') + ' white--text'
                + (this.wordWrap ? '' : ' no-wrap')
        },

        adjustLVR(percent, groupIndex) {
            console.log('adjusing lvr for group ', groupIndex)
            
            let group = this.groups[groupIndex]
            let loans = this.groups[groupIndex].loans
            const maxLoanAmount = Math.max.apply(Math,loans.map(function(o){return o.amount}))
            const loan = loans.find(function(o){ return o.amount == maxLoanAmount })
            const idx = loans.indexOf(loan)
            
            const desiredTotalLoanAmount = group.propertyTotal * percent / 100 
            
            const amountToSubtract = group.loanTotal - desiredTotalLoanAmount
            
            loan.amount = maxLoanAmount - amountToSubtract

            Vue.set(this.diagramData[groupIndex].loans, idx, loan)

            this.saveDiagram()

        },

        saveDiagram() {
            //try no delay
            console.log('saving...')
            let result = {...this.passBack}
            result.diagram = this.diagramData
            result.value = LoanHelpers.diagramPicture(this.groups)
            this.$emit('save', result)
        },

        shortenAddress(address) {
            let pos = address.indexOf(',')
            if(pos)
                return address.substr(0, pos)

            return address
        }
    },
    created() {
        if(this.diagram)
            this.diagramData = this.diagram
    }
}
</script>

<style scoped>

.diagram-group {
    border: dotted 4px #ddd;
    padding: 2px; border-radius: 7px;
    margin-bottom:8px;
}

.attribute-chip{
    border: dotted 2px transparent;
}
.attribute-chip.selected{
    border-color: #42a5f5;
}

.diagram-bar {
    padding: 3px 6px;
    border-radius:5px;
    margin-right:5px; margin-bottom:5px;
    border: solid 3px transparent;
}

.no-wrap {
    white-space: nowrap;
}

.diagram-space {
    color: #bbb; font-weight:500
}

.diagram-space:hover {
    color: #aaa; font-weight:600
}

.property {
    background-color: #ff9800;
    color:rgba(255, 255, 255, 0.7)
}

.property.investment {
    background-color: #ef6c00;
}

.loan {
    background-color: #42a5f5;
    color:rgba(255, 255, 255, 0.7);
}

.loan.selected {
    border-style: dotted;
    border-color: white;
    box-shadow: 0 0 15px rgba(23, 124, 224, 0.904);
}

.loan .amount {
    color:white;
}

.loan.investment {
    background-color: #5c6bc0
}

/* Hover Colours */

.property:hover {
    background-color: #ff9900d3;
}

.property.investment:hover {
    background-color: #ef6c00e0;
}

.loan:hover {
    background-color: #42a4f5dc;
}

.loan.investment:hover {
    background-color: #5c6bc0dc;
}

.loan.existing {
    background-color: transparent;
    border: solid 1px #ddd;
    color: #bbb
}
.loan.existing .amount {
    color: #999
}
   
</style>




// WEBPACK FOOTER //
// LoanDiagram.vue?19ff6eb3